// Module
var code = "<p>This is a one-time payment. To set up automatic monthly payments, sign up for <a href=\"/manage/repaying-your-loan/ways-to-pay/direct-debit\">Direct Debit</a>.</p> ";
// Exports
export default code;